export function parseApiFaqItems(raw) {
  if (!raw) return [];
  let data = raw;

  if (typeof raw === 'string') {
    const s = raw.trim();
    if (!s || s === 'null' || s === 'undefined' || s === '[]' || s === '{}') return [];
    try {
      data = JSON.parse(s);
    } catch {
      return [];
    }
  }

  if (!Array.isArray(data)) return [];

  let qCounter = 0;
  return data.flatMap((group) => {
    const category = group?.category || '';
    const categoryId =
      category
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '') || 'all';
    const questions = Array.isArray(group?.questions) ? group.questions : [];

    return questions
      .map((item) => {
        const question = item?.question || '';
        const answer = item?.answer || '';
        if (!question && !answer) return null;
        qCounter += 1;
        return {
          id: `Q${qCounter}`,
          category: categoryId,
          categoryName: category,
          question,
          answer,
        };
      })
      .filter(Boolean);
  });
}
